var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_box",class:{
    moveLeft: _vm.left,
    moveRight: _vm.right
  },style:({ 'top': _vm.pageY + 'px', 'left': _vm.pageX + 'px' }),on:{"click":function($event){return _vm.goHome()},"touchstart":function($event){$event.stopPropagation();return _vm.mousedownFun.apply(null, arguments)},"touchend":function($event){$event.stopPropagation();return _vm.mouseupFun.apply(null, arguments)}}},[_c('img',{attrs:{"src":_vm.$store.state.publicImgUrl+'static/hxlpt/discovers/muscle/icon_home.png'}}),_c('br'),_c('span',[_vm._v("首页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }